import { render, staticRenderFns } from "./MyHistoriana.vue?vue&type=template&id=21cff690&"
import script from "./MyHistoriana.vue?vue&type=script&lang=js&"
export * from "./MyHistoriana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports